@if (isRecording) {
  <button matRipple (click)="onStop($event)" class="stop">
    <mat-icon>stop</mat-icon>
  </button>
}
@if (!isRecording && !isPlaying) {
  <button matRipple (click)="onPlay($event)">
    <mat-icon>play_arrow</mat-icon>
  </button>
}
@if (!isRecording && isPlaying) {
  <button matRipple (click)="onPause($event)">
    <mat-icon>pause</mat-icon>
  </button>
}

@if (isRecording) {
  <div class="recording-content">
    <div>Recording...</div>
    <div class="duration">{{ recordingDuration | msToTime }}</div>
  </div>
}

<div class="slider-container" [hidden]="isRecording">
  <input
    #audioSlider
    class="slider"
    id="audio-range"
    type="range"
    min="0"
    [(ngModel)]="seekValue"
    [max]="audio ? (audio.duration * 1000 | ceil) : (duration ?? 0)"
    (input)="onSeek($event)"
    (mousedown)="onSeekStart($event)"
    (mouseup)="onSeekEnd($event)"
  />
</div>

@if (showDurationInfo) {
  <div class="duration">
    {{ displayDuration | msToTime }}
  </div>
}
